import { type UseQueryResult, useQuery } from 'react-query';
import {
  UserDefinedFieldsSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsByModuleIdDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

const useGetUDFByModuleId = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  moduleId: number
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsByModuleIdDto[] | undefined,
  unknown
> => {
  const userDefinedFieldsByModuleId = useQuery(
    ['getUserDefinedFieldsByModuleId', moduleId],
    async () => {
      return await handleRequest(
        UserDefinedFieldsSharedService.getApiCustomerApiAppUserDefinedFieldsUserDefinedFieldsByModuleId(
          moduleId
        )
      );
    }
  );

  return userDefinedFieldsByModuleId;
};

export default useGetUDFByModuleId;
